<template>
    <div
        :data-component-name="$options.name"
        v-if="!disabledIDs.includes(field.id) && $root.canadaPost_APIKey"
        :class="((!field.inputClass) ? 'o-grid-12' : field.inputClass)"
    >
        <inputlabel :field="field" v-if="field.inputLabel != ''"/>
        <input
            class="o-hidden-field-group"
            v-for="(mapping, mi) in field.inputAddressMapping"
            :key="mi"
            :id="'input-' + mapping.fieldName + '-' + field.id"
            :name="(repeaterIndex !== null) ? mapping.fieldName+'['+repeaterIndex+']' : mapping.fieldName"
            :required="(mapping.isRequired === true) ? 'required' : false"
            :value="getFieldValue(mapping.fieldCode)"
            type="text"
            autocomplete="nope"
        >
        <div v-show="!isValid || addressCardBody==''">
            <div class="o-form__item o-input-address-finder">
                <input
                    ref="input"
                    class="o-input"
                    :class="{ 'readonly': field.inputReadonly === true }"
                    v-on="readOnlyHandlers"
                    type="text"
                    :id="'input-'+field.id"
                    :name="field.inputName"
                    :placeholder="field.inputPlaceholder"
                    @input="$refs.input.setCustomValidity('')"
                    :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : 'nope'"
                >
                <div class="o-form__validation">
                    <span class="o-form__validation__required">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                    <span class="o-form__validation__error">
                        {{ _t('L\'adresse sélectionnée semble invalide.') }}
                    </span>
                </div>
            </div>
        </div>

        <div class="o-input -input-address" v-show="isValid && addressCardBody!=''">
            <button class="o-input__close" style="float:right" @click.prevent="field.value=null">
                <span></span>
                <span></span>
            </button>
            <div v-html="addressCardBody"></div>
        </div>
        <span class="o-form__instruction" v-if="field.inputInstructions && String(field.inputInstructions).trim() != ''">
            <small v-html="field.inputInstructions"></small>
        </span>

    </div>
</template>
<script>
    export default {
        name: 'Input-addressbycanadapost',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            repeaterIndex: {
                type: [String, Number],
                default: null,
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
            return {
                isValid: true,
                invalidRelatedFields: [],
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                },
                addressCardBody: '',
                myPCA: null,
                internationalProvinceName: {
                    'AB' : 'Alberta',
                    'BC': 'British Columbia',
                    'MB': 'Manitoba',
                    'NB': 'New Brunswick',
                    'NL': 'Newfoundland and Labrador',
                    'NT': 'Northwest Territories',
                    'NS': 'Nova Scotia',
                    'NU': 'Nunavut',
                    'ON': 'Ontario',
                    'PE': 'Prince Edward Island',
                    'QC': 'Quebec',
                    'SK': 'Saskatchewan',
                    'YT': 'Yukon',
                }
        	}
        },
        mounted() {

            this.emitter.on('set-invalid-fields', (data) => {
                if (!this.$el || !this.$root.canadaPost_APIKey) return;
                if (this.isDisabled) return;

                if (this.$refs.input) this.$refs.input.setCustomValidity("");
                this.isValid = true;

                let onPage = this.$el.querySelectorAll(data.map((id) => '#' + id).join(', '));
                if (onPage.length > 0) {
                    this.isValid = false
                    this.$nextTick(() => {
                        this.$refs.input.setCustomValidity("invalid");
                    });
                }
            });

            this.setAddressCardBody();
            
        },
        computed: {
            isDisabled() {
                return this.disabledIDs.includes(this.field.id);
            },
        },
        watch: {
            isDisabled: {
                handler: function (val) {
                    if (val) {
                        this.myPCA = null;
                    } else {
                        if(this.myPCA===null) this.initAddressFinder();
                    }
                },
                immediate: true
            },

            'field.value': {
                handler: function (val) {
                    this.setAddressCardBody();                
                },
                deep: true
            },

        },
        methods: {

            getFieldValue(fieldCode) {

                if (typeof this.field.value != 'undefined' && this.field.value !== null && this.field.value[fieldCode] !== null && this.field.value[fieldCode] != '') {
                    if (fieldCode == 'ProvinceName' && this.field.value?.ProvinceCode && String(this.field.value.ProvinceCode).trim() != '' && this.internationalProvinceName[this.field.value.ProvinceCode] ) {
                        return this.internationalProvinceName[this.field.value.ProvinceCode];
                    }
                    return this.field.value[fieldCode];
                }
                return '';
            },

            initAddressFinder() {
                this.$nextTick(() => {
                    this.myPCA = null;

                    let fields = [
                        { element: this.field.inputName, field: "", mode: pca.fieldMode.SEARCH },
                    ]

                    let options = {
                        key: this.$root.canadaPost_APIKey,
                        setCursor: true,
                        onlyInputs: true,
                        suppressAutocomplete: false,
                    }
                    this.myPCA = new pca.Address(fields, options);
                    if (this.field.inputAddressMapping) {
                        this.myPCA.listen('populate', (address) => {
                            this.isValid = true;
                            this.field.value = Object.assign({}, address);
                        });
                    }
                });
            },

            setAddressCardBody() {
                this.addressCardBody = '';

                if (typeof this.field.value != 'undefined' && this.field.value !== null && this.field.value.Line1 !== null && this.field.value.Line1 !== '') {

                    let value = this.field.value.Line1;
                    if (value && value !== null && value !== '') {
                        this.addressCardBody += value + '<br>';
                    }

                    value = this.field.value.Line2;
                    if (value && value !== null && value !== '') {
                        this.addressCardBody += value + '<br>';
                    }
                    value = this.field.value.City;
                    if (value && value !== null && value !== '') {
                        this.addressCardBody += value + ' ';
                    }
                    // value = this.field.value.ProvinceName;
                    // if (value && value !== null && value !== '') {
                    //     this.addressCardBody += value + ' ';
                    // }
                    value = this.field.value.ProvinceCode;
                    if (value && value !== null && value !== '') {
                        this.addressCardBody += value + ' ';
                    }
                    value = this.field.value.PostalCode;
                    if (value && value !== null && value !== '') {
                        this.addressCardBody += value + ' ';
                    }
                }
                
            },

            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            }

        },
    }
</script>